import angular from 'angular';
import display from './builder/display.html';
import validate from './builder/validate.html';

angular.module('app').run(/* @ngInject */ (
	/** @type {import('angular').ITemplateCacheService} */ $templateCache,
) => {
	$templateCache.put('kform/components/jsoneditor/display.html', display);
	$templateCache.put('kform/components/jsoneditor/validate.html', validate);
});
